<template>
  <div class="wrapper">
    <div class="unselect" :style="textStyle" @click="$emit('clicked')">{{ title }}</div>

    <div class="desc-wrapper">
      <span :style="descriptionStyle">{{ description }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "text-tip",
    props: {
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      },
      textStyle: {
        type: Object,
        required: false
      }
    },
    computed: {
      descriptionStyle () {
        let deco = {
          backgroundColor: '#f0f0f0',
          color: '#4f4f4f',
          padding: '3px',
          borderRadius: '6px',
          fontSize: '10px',
          lineHeight: '1.5'
        }
        if (this.textStyle.margin) {
          deco.margin = this.textStyle.margin
        }
        if (this.textStyle.marginLeft) {
          deco.marginLeft = this.textStyle.marginLeft
        }
        if (this.textStyle.marginRight) {
          deco.marginLeft = this.textStyle.marginLeft
        }
        if (this.textStyle.marginTop) {
          deco.marginTop = this.textStyle.marginTop
        }
        if (this.textStyle.marginBottom) {
          deco.marginBottom = this.textStyle.marginBottom
        }
        return deco;
      }
    }
  }
</script>

<style type="stylus" lang="stylus" scoped>
  .wrapper
    position relative

  .wrapper .desc-wrapper
    display none

  .wrapper:hover .desc-wrapper
    display block

  .desc-wrapper
    position absolute
    top 25px
    left 0
    width 250px
    z-index 10

</style>
